/**
 * @fileoverview WEB-942 — one Discover count formatter.
 *
 * v3 draws every surface count grouped (`1,391 live now`, `1,391 IN RANGE`).
 * The shipped surface mixed bare integers with locally grouped figures. This
 * helper is the single spelling so the coord strip, count-up, results bar,
 * hero meta, and list tail cannot drift.
 *
 * THE LOCALE IS PINNED AT MODULE SCOPE ON PURPOSE. A locale-default number
 * format (or `new Intl.NumberFormat()` with no locale) resolves the runtime default,
 * which can differ between the Node SSR render and the browser (`1,234` vs
 * `1.234` vs `1 234`). React then reports a hydration mismatch on the digit
 * separator — a defect that never reproduces on the machine that shipped it.
 * Constructing the formatter once also keeps every frame of `CountUpNumber`
 * on the same instance.
 *
 * `en-US` is the app's own copy locale, so pinning it is not a localisation
 * regression: nothing here is translated yet.
 */

const COUNT_FORMATTER = new Intl.NumberFormat('en-US');

/**
 * Formats a Discover count for display: `1391` → `"1,391"`, `0` → `"0"`.
 *
 * Callers own emptiness rules — this helper never decides that a value is
 * absent. Surfaces that must not paint a pending `0` still skeleton first.
 */
export function formatCount(n: number): string {
  return COUNT_FORMATTER.format(n);
}
